export default __webpack_public_path__ + "static/media/Logo-only.5415d2aa.png";